import { Box, Typography } from '@mui/material';
import { IPageWrapperProps } from './interfaces';
import { useStyles } from './styles';

const PageWrapper = ({
  children,
  bottomElement = null,
  title = '',
  sx = {},
}: IPageWrapperProps) => {
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      <Box sx={classes.content}>
        {title && <Typography sx={classes.title}>{title}</Typography>}
        <Box sx={classes.children}>{children}</Box>
      </Box>
      {bottomElement && (
        <Box sx={{ ...classes.bottomElement, ...sx }}>{bottomElement}</Box>
      )}
    </Box>
  );
};

export default PageWrapper;
